import React from "react";
import Typography from "@material-ui/core/Typography";
import { Link } from "@material-ui/core";
import clsx from "clsx";
import { getFileSize } from "../../modules/academic/modals/helpers/helperFunctions";
import { ReactComponent as UploadedFileIcon } from "../../assets/svg/uploaded-file.svg";
import { urlNormalizer } from "../../helpers";
import OverflowTooltip from "../OverflowTooltip/OverflowTooltip";
import IconButton from "../IconButton";
import FontIcon from "../FontIcon";
import { useStyles } from "./useStyles";
import { IFilePreviewProps } from "./types";

const NO_FILE_UPLOADED = "No file uploaded";

export const PreviewFile = ({
  file,
  removeFile,
  isViewMode,
}: IFilePreviewProps) => {
  const classes = useStyles();

  return (
    <div className={classes.flexContainer}>
      <div className={classes.iconInfoContainer}>
        <UploadedFileIcon />
        {!file && isViewMode ? (
          <div className={classes.infoNoFileTextContainer}>
            <Typography>{NO_FILE_UPLOADED}</Typography>
          </div>
        ) : (
          <div className={classes.infoTextContainer}>
            <Typography>
              <Link
                className={clsx(
                  file?.path || file?.preview
                    ? classes.viewModeLink
                    : classes.notLink,
                )}
                href={file?.path ?? urlNormalizer(file?.preview)}
                target="_blank"
                underline="none"
              >
                <OverflowTooltip text={file!.name} />
              </Link>
            </Typography>
            <Typography>File size: {getFileSize(file!.size)}</Typography>
          </div>
        )}
      </div>

      {!isViewMode && !file?.hasOwnProperty("isRemovable") && (
        <div>
          <IconButton color={"delete"} onClick={() => removeFile!(file!)}>
            <FontIcon fontSize={"small"} name={"delete"} />
          </IconButton>
        </div>
      )}
    </div>
  );
};
